/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { getUrlWithoutLoginDetails } from 'common/url';

export const STRINGS = {
  PRODUCT: {
    PRIMARY_CARE: 'PRIMARY_CARE',
    E_TRIAGE: 'E_TRIAGE',
    E_SPECIALIST: 'E_SPECIALIST',
  },
  API: {
    ROOT_URL: practiceId => 'http://localhost:8086',
    IE_ROOT_URL: practiceId => `http://${practiceId}.localhost:8081/cors`,
    ROOT_PATH: '/consultation',
    SUBMISSION_URL: practiceId => 'https://bd-test.econsulttest.health/api/consultation/submitsession',
    INFO_URL: '/management/info',
    POSTCODE_URL: (practiceId, postcode) => `https://api.postcodes.io/postcodes/${postcode}/autocomplete`,
    ADDRESSES_URL: (practiceId, postcode) => null,
  },
  QUESTION_TYPE: {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE',
    ALLMULTIPLE: 'ALLMULTIPLE',
    DATE: 'DATE',
    FREETEXT: 'FREETEXT',
    FREETEXTSHORT: 'FREETEXTSHORT',
    TIME: 'TIME',
    HEIGHT: 'HEIGHT',
    WEIGHT: 'WEIGHT',
    ADDRESS: 'ADDRESS',
    ENDSTATE: 'ENDSTATE',
    COMPOUND: 'COMPOUND',
    BLOODPRESSURE: 'BLOODPRESSURE',
    BODYMASSINDEX: 'BODYMASSINDEX',
    PHOTO: 'PHOTO',
    LOGIN: 'LOGIN',
    SEARCH: 'SEARCH',
  },
  RESPONSE_TYPE: {
    ENDSTATE_EMERGENCY: 'ENDSTATE_EMERGENCY',
    ENDSTATE_URGENT: 'ENDSTATE_URGENT',
    ENDSTATE_URGENT_MH: 'ENDSTATE_URGENT_MH',
    ENDSTATE_REDIRECT: 'ENDSTATE_REDIRECT',
    ENDSTATE_REDIRECT_HMRC: 'ENDSTATE_REDIRECT_HMRC',
    ENDSTATE_DENTAL: 'ENDSTATE_DENTAL',
    ENDSTATE_COMPLETE: 'ENDSTATE_COMPLETE',
    ENDSTATE_COMPLETE_ADMIN: 'ENDSTATE_COMPLETE_ADMIN',
    ENDSTATE_COMPLETE_PATIENT_RESPONSE: 'ENDSTATE_COMPLETE_PATIENT_RESPONSE',
    ENDSTATE_COMPLETE_PATIENT_REGISTRATION: 'ENDSTATE_COMPLETE_PATIENT_REGISTRATION',
    ENDSTATE_COMPLETE_AUTISM_PRE_HEALTH: 'ENDSTATE_COMPLETE_AUTISM_PRE_HEALTH',
    ENDSTATE_COMPLETE_OP_AANDA_MSK: 'ENDSTATE_COMPLETE_OP_AANDA_MSK',
    ENDSTATE_SUICIDAL: 'ENDSTATE_SUICIDAL',
    ENDSTATE_INELIGIBLE: 'ENDSTATE_INELIGIBLE',
    ENDSTATE_NO_ADDRESS: 'ES_NO_ADDRESS',
    ADVICE_EMERGENCY: 'ADVICE_EMERGENCY',
    ADVICE_EMERGENCY_MH: 'ADVICE_EMERGENCY_MH',
    ADVICE_URGENT: 'ADVICE_URGENT',
    ADVICE_URGENT_MH: 'ADVICE_URGENT_MH',
    ADVICE_REDIRECT: 'ADVICE_REDIRECT',
    ADVICE_DENTAL: 'ADVICE_DENTAL',
    ERROR: 'ERROR',
    QUESTION: 'QUESTION',
    QUESTION_SUICIDAL_CONFIRMATION: 'QUESTION_SUICIDAL_CONFIRMATION',
    QUESTION_END_OF_PRELIMINARY: 'PRELIM_END',
  },
  TREATMENT_CATEGORIES_REDUCER: {
    GET_TREATMENT_CATEGORIES_REQUEST: 'consultation/GET_TREATMENT_CATEGORIES_REQUEST',
    GET_TREATMENT_CATEGORIES_SUCCESS: 'consultation/GET_TREATMENT_CATEGORIES_SUCCESS',
    GET_TREATMENT_CATEGORIES_ERROR: 'consultation/GET_TREATMENT_CATEGORIES_ERROR',
  },
  CONSULTATION_REDUCER: {
    SET_DISCLAIMER_QUESTION: 'consultation/SET_DISCLAIMER_QUESTION',
    GET_FIRST_QUESTION_SUCCESS: 'consultation/GET_FIRST_QUESTION_SUCCESS',
    GET_FIRST_PRELIM_QUESTION_SUCCESS: 'consultation/GET_FIRST_PRELIM_QUESTION_SUCCESS',
    GET_NEXT_QUESTION_SUCCESS: 'consultation/GET_NEXT_QUESTION_SUCCESS',
    GET_NEXT_QUESTION_ERROR: 'consultation/GET_NEXT_QUESTION_ERROR',
    GET_NEXT_QUESTION_INVALID_REQUEST_ERROR: 'consultation/GET_NEXT_QUESTION_INVALID_REQUEST_ERROR',
    GET_NEXT_QUESTION_COMPOUND_QUESTION_ERROR: 'consultation/GET_NEXT_QUESTION_COMPOUND_QUESTION_ERROR',
    SYNC_TO_API_CURRENT_QUESTION: 'consultation/SYNC_TO_API_CURRENT_QUESTION',
    SELECT_SINGLE_ANSWER: 'consultation/SELECT_SINGLE_ANSWER',
    SELECT_MULTIPLE_ANSWERS: 'consultation/SELECT_MULTIPLE_ANSWERS',
    DESELECT_MULTIPLE_ANSWERS: 'consultation/DESELECT_MULTIPLE_ANSWERS',
    GET_PREVIOUS_QUESTION_SUCCESS: 'consultation/GET_PREVIOUS_QUESTION_SUCCESS',
    UPDATE_DATE_DAY: 'consultation/UPDATE_DATE_DAY',
    UPDATE_DATE_MONTH: 'consultation/UPDATE_DATE_MONTH',
    UPDATE_DATE_YEAR: 'consultation/UPDATE_DATE_YEAR',
    UPDATE_FREETEXT_ANSWER: 'consultation/UPDATE_FREETEXT_ANSWER',
    SUBMIT_CONSULTATION_REQUEST: 'consultation/SUBMIT_CONSULTATION_REQUEST',
    SUBMIT_CONSULTATION_SUCCESS: 'consultation/SUBMIT_CONSULTATION_SUCCESS',
    SUBMIT_CONSULTATION_ERROR: 'consultation/SUBMIT_CONSULTATION_ERROR',
    GET_FIRST_QUESTION_REQUEST: 'consultation/GET_FIRST_QUESTION_REQUEST',
    GET_FIRST_QUESTION_ERROR: 'consultation/GET_FIRST_QUESTION_ERROR',
    GET_FIRST_PRELIM_QUESTION_REQUEST: 'consultation/GET_FIRST_PRELIM_QUESTION_REQUEST',
    GET_FIRST_PRELIM_QUESTION_ERROR: 'consultation/GET_FIRST_PRELIM_QUESTION_ERROR',
    GET_NEXT_QUESTION_REQUEST: 'consultation/GET_NEXT_QUESTION_REQUEST',
    GET_PREVIOUS_QUESTION_REQUEST: 'consultation/GET_PREVIOUS_QUESTION_REQUEST',
    GET_PREVIOUS_QUESTION_ERROR: 'consultation/GET_PREVIOUS_QUESTION_ERROR',
    ADD_ALLMULTIPLE_VALIDATION: 'consultation/ADD_ALLMULTIPLE_VALIDATION',
    GET_API_VERSION_REQUEST: 'consultation/GET_API_VERSION_REQUEST',
    GET_API_VERSION_SUCCESS: 'consultation/GET_API_VERSION_SUCCESS',
    GET_API_VERSION_ERROR: 'consultation/GET_API_VERSION_ERROR',
    SET_DATE_ANSWER_ID: 'consultation/SET_DATE_ANSWER_ID',
    SET_START_TIME: 'consultation/SET_START_TIME',
    SET_PAUSED: 'consultation/SET_PAUSED',
    GET_TREATMENT_CATEGORY_REQUEST: 'consultation/GET_TREATMENT_CATEGORY_REQUEST',
    GET_TREATMENT_CATEGORY_SUCCESS: 'consultation/GET_TREATMENT_CATEGORY_SUCCESS',
    GET_TREATMENT_CATEGORY_ERROR: 'consultation/GET_TREATMENT_CATEGORY_ERROR',
    NO_FURTHER_QUESTIONS_ERROR: 'consultation/NO_FURTHER_QUESTIONS_ERROR',
    NO_PREVIOUS_QUESTIONS_ERROR: 'consultation/NO_PREVIOUS_QUESTIONS_ERROR',
    SET_PRACTICE: 'consultation/SET_PRACTICE',
    DUPLICATE_SUBMISSION_ERROR: 'consultation/DUPLICATE_SUBMISSION_ERROR',
    SET_FEDERATED_LOGIN_PROVIDER: 'consultation/SET_FEDERATED_LOGIN_PROVIDER',
    UPDATE_COMPOUND_ANSWERS: 'consultation/UPDATE_COMPOUND_ANSWERS',
    VALIDATE_POSTCODE_REQUEST: 'consultation/VALIDATE_POSTCODE_REQUEST',
    VALIDATE_POSTCODE_SUCCESS: 'consultation/VALIDATE_POSTCODE_SUCCESS',
    VALIDATE_POSTCODE_ERROR: 'consultation/VALIDATE_POSTCODE_ERROR',
    FIND_ADDRESSES_REQUEST: 'consultation/FIND_ADDRESSES_REQUEST',
    FIND_ADDRESSES_SUCCESS: 'consultation/FIND_ADDRESSES_SUCCESS',
    FIND_ADDRESSES_ERROR: 'consultation/FIND_ADDRESSES_ERROR',
    CLEAR_ADDRESSES: 'consultation/CLEAR_ADDRESSES',
    CLOSE_DUPLICATE_SUBMISSION_MODAL: 'consultation/CLOSE_DUPLICATE_SUBMISSION_MODAL',
    SET_ENCOUNTER_ID: 'consultation/SET_ENCOUNTER_ID',
    UPDATE_BP_READING: 'consultation/UPDATE_BP_READING',
    ADD_BP_READING: 'consultation/ADD_BP_READING',
    REMOVE_BP_READING: 'consultation/REMOVE_BP_READING',
    UPDATE_BMI_WEIGHT: 'consultation/UPDATE_BMI_WEIGHT',
    UPDATE_BMI_HEIGHT: 'consultation/UPDATE_BMI_HEIGHT',
    TOGGLE_BMI_WEIGHT: 'consultation/TOGGLE_BMI_WEIGHT',
    TOGGLE_BMI_HEIGHT: 'consultation/TOGGLE_BMI_HEIGHT',
    ADD_PHOTO: 'consultation/ADD_PHOTO',
    DELETE_PHOTO: 'consultation/DELETE_PHOTO',
    UPDATE_PHOTO_DESCRIPTION: 'consultation/UPDATE_PHOTO_DESCRIPTION',
    GET_LAST_QUESTION_REQUEST: 'consultation/GET_LAST_QUESTION_REQUEST',
    GET_LAST_QUESTION_SUCCESS: 'consultation/GET_LAST_QUESTION_SUCCESS',
    GET_LAST_QUESTION_ERROR: 'consultation/GET_LAST_QUESTION_ERROR',
    GET_PUBLIC_HEALTH_ALERT_REQUEST: 'consultation/GET_PUBLIC_HEALTH_ALERT_REQUEST',
    GET_PUBLIC_HEALTH_ALERT_SUCCESS: 'consultation/GET_PUBLIC_HEALTH_ALERT_SUCCESS',
    GET_PUBLIC_HEALTH_ALERT_ERROR: 'consultation/GET_PUBLIC_HEALTH_ALERT_ERROR',
    INTERNAL_REDIRECT_REQUEST: 'consultation/INTERNAL_REDIRECT_REQUEST',
    INTERNAL_REDIRECT_SUCCESS: 'consultation/INTERNAL_REDIRECT_SUCCESS',
    SAVE_IS_LOGGED_IN: 'consultation/SAVE_IS_LOGGED_IN',
    SET_PRODUCT: 'consultation/SET_PRODUCT',
    SET_PATIENT: 'consultation/SET_PATIENT',
    RETURN_TO_WEBFLOW: 'consultation/RETURN_TO_WEBFLOW',
    OUT_OF_HOURS_ERROR: 'consultation/OUT_OF_HOURS_ERROR',
    SET_TWO_WAY_MESSAGE_ID: 'consultation/SET_TWO_WAY_MESSAGE_ID',
    SET_IS_CONTINUE_AS_GUEST: 'consultation/SET_IS_CONTINUE_AS_GUEST',
    UPDATE_SEARCH_TERM: 'consultation/UPDATE_SEARCH_TERM',
    GET_TYPE_AHEAD_SEARCH_REQUEST: 'consultation/GET_TYPE_AHEAD_SEARCH_REQUEST',
    GET_TYPE_AHEAD_SEARCH_SUCCESS: 'consultation/GET_TYPE_AHEAD_SEARCH_SUCCESS',
    GET_TYPE_AHEAD_SEARCH_ERROR: 'consultation/GET_TYPE_AHEAD_SEARCH_ERROR',
    SELECT_SEARCH_RESULT: 'consultation/SELECT_SEARCH_RESULT',
    SET_EXECUTION_ID: 'consultation/SET_EXECUTION_ID',
    UPLOAD_PHOTO_TO_S3_REQUEST: 'consultation/UPLOAD_PHOTO_TO_S3_REQUEST',
    UPLOAD_PHOTO_TO_S3_ERROR: 'consultation/UPLOAD_PHOTO_TO_S3_ERROR',
    UPLOAD_PHOTO_TO_S3_SUCCESS: 'consultation/UPLOAD_PHOTO_TO_S3_SUCCESS',
    DELETE_PHOTO_FROM_S3_REQUEST: 'consultation/DELETE_PHOTO_FROM_S3_REQUEST',
    DELETE_PHOTO_FROM_S3_ERROR: 'consultation/DELETE_PHOTO_FROM_S3_ERROR',
    DELETE_PHOTO_FROM_S3_SUCCESS: 'consultation/DELETE_PHOTO_FROM_S3_SUCCESS',

    /**
     * @return {string}
     */
    CONSULTATION_SUCCESS: function (action) {
      return `consultation/${action}_SUCCESS`;
    },
    /**
     * @return {string}
     */
    CONSULTATION_ERROR: function (action) {
      return `consultation/${action}_ERROR`;
    },
    UPDATE_DATE_ANSWER: dateUnit => {
      return `consultation/UPDATE_DATE_${dateUnit}`;
    },
  },
  FLAGS_REDUCER: {
    SET_IS_CLINICAL_REVIEW_MODE: 'flags/SET_IS_CLINICAL_REVIEW_MODE',
    SET_FORCE_NHS_LOGIN_MODE: 'flags/SET_FORCE_NHS_LOGIN_MODE',
    CLEAR_SHOW_SESSION_EXPIRY_VALIDATION_ON_LOAD: 'flags/CLEAR_SHOW_SESSION_EXPIRY_VALIDATION_ON_LOAD',
    SET_IS_ETRIAGE_BACK_HIDDEN: 'flags/SET_IS_ETRIAGE_BACK_HIDDEN',
  },
  LOGIN_REDUCER: {
    UPDATE_DEV_LOGIN: 'login/UPDATE_DEV_LOGIN',
    REDIRECT_TO_NHS_STUB_LOGIN: 'login/REDIRECT_TO_NHS_STUB_LOGIN',
    SUBMIT_DEV_LOGIN: 'login/SUBMIT_DEV_LOGIN',
    UPDATE_LOGIN_STATUS: 'login/UPDATE_LOGIN_STATUS',
    SET_TEST_CODE: 'login/SET_TEST_CODE',
    LOGOUT_USER: 'login/LOGOUT_USER',
  },
  SESSION_REDUCER: {
    RESTART_SESSION: 'session/RESTART_SESSION',
    RESET_SESSION_TIMEOUT: 'session/RESET_SESSION_TIMEOUT',
    OPEN_SESSION_EXPIRY_WARNING: 'session/OPEN_SESSION_EXPIRY_WARNING',
    RE_RESET_SESSION_TIMEOUT: 'session/RE_RESET_SESSION_TIMEOUT',
    CLEAR_SESSION_TIMEOUT: 'session/CLEAR_SESSION_TIMEOUT',
    SET_SESSION_EXPIRY_VALIDATION: 'session/SET_SESSION_EXPIRY_VALIDATION',
    CLOSE_SESSION_EXPIRY_WARNING: 'session/CLOSE_SESSION_EXPIRY_WARNING',
    CLOSE_DEMO_NOTICE: 'session/CLOSE_DEMO_NOTICE',
    OPEN_LEAVE_PAGE_WARNING: 'session/OPEN_LEAVE_PAGE_WARNING',
    CLOSE_LEAVE_PAGE_WARNING: 'session/CLOSE_LEAVE_PAGE_WARNING',
    GA_INITIALISED: 'session/GA_INITIALISED',
    EXTEND_SESSION_REQUEST: 'session/EXTEND_SESSION_REQUEST',
    EXTEND_SESSION_SUCCESS: 'session/EXTEND_SESSION_SUCCESS',
    EXTEND_SESSION_ERROR: 'session/EXTEND_SESSION_ERROR',
    SET_CONNECTIVITY_MESSAGE: 'session/SET_CONNECTIVITY_MESSAGE',
    CLEAR_VALIDATION_MESSAGE: 'session/CLEAR_VALIDATION_MESSAGE',
    CANCEL_PROGRESS: 'session/CANCEL_PROGRESS',
    CONFIRM_LEAVE_PAGE: 'session/CONFIRM_LEAVE_PAGE',
    CLOSE_CANCEL_PROGRESS_WARNING: 'session/CLOSE_CANCEL_PROGRESS_WARNING',
  },
  TRIAGE_LEVEL: {
    NORMAL: 1,
    GP_CAUTION: 2,
    RED_FLAG: 3,
    ADVICE_URGENT: 4,
    ADVICE_EMERGENCY: 5,
    ADVICE_URGENT_MH: 6,
    ADVICE_EMERGENCY_MH: 7,
    ADVICE_REDIRECT: 10,
    REDIRECT: 20,
    REDIRECT_HMRC: 21,
    INELIGIBLE: 22,
    CV19_EMERGENCY: 55,
    DENTAL: 91,
    URGENT: 96,
    EMERGENCY: 97,
    SUICIDAL: 99,
  },
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
  API_REQUEST_TIMEOUT: {
    RESPONSE: 30000,
    DEADLINE: 30000,
  },
  S3_BUCKET: '',
  FEDERATED_LOGIN_PROVIDER: {
    NHS_LOGIN_STUB: {
      DISPLAY_NAME: '(Stub) NHS login',
    },
    NHS_LOGIN_SANDPIT: {
      DISPLAY_NAME: '(Sandpit) NHS login',
      REDIRECT_URL: `https://auth.sandpit.signin.nhs.uk/authorize?scope=openid%20profile&client_id=eConsult&redirect_uri=${encodeURI('https://assets.nhs-g3-test.webgp.com/')}&response_type=code&vtr=P9.Cp.Cd&state=${getUrlWithoutLoginDetails(window.location)}`,
    },
    NHS_LOGIN_ASSURANCE: {
      DISPLAY_NAME: '(Assurance) NHS login',
      REDIRECT_URL: `https://auth.aos.signin.nhs.uk/authorize?scope=openid%20profile%20email%20profile_extended%20phone%20gp_registration_details&client_id=eConsult&redirect_uri=${encodeURI('https://assets.nhs-g3-test.webgp.com/')}&response_type=code&vtr=%5B%22P9.Cp.Cd%22%2C%20%22P9.Cp.Ck%22%2C%20%22P9.Cm%22%5D&state=${getUrlWithoutLoginDetails(window.location)}`,
    },
    NHS_LOGIN_LIVE: {
      DISPLAY_NAME: 'NHS login',
      REDIRECT_URL: `https://auth.login.nhs.uk/authorize?scope=openid%20profile%20email%20profile_extended%20phone%20gp_registration_details&client_id=eConsult&redirect_uri=${encodeURI('https://assets.webgp.com/')}&response_type=code&vtr=%5B%22P9.Cp.Cd%22%2C%20%22P9.Cp.Ck%22%2C%20%22P9.Cm%22%5D&state=${getUrlWithoutLoginDetails(window.location)}`,
    },
  },
  DEV_LOGIN_ENABLED: true,
  VALIDATION_ERROR_CODES: {
    INVALID_QUESTION_ID: 'INVALID_QUESTION_ID',
    ANSWER_LENGTH_GT_MAX: 'ANSWER_LENGTH_GT_MAX',
    ANSWER_LENGTH_LT_MIN: 'ANSWER_LENGTH_LT_MIN',
    MISSING_ANSWER: 'MISSING_ANSWER',
  },
  SERVICE_ERROR_CODE: {
    SESSION_EXPIRED: 511,
    OUT_OF_HOURS: 544,
    CONTENT_TYPE_UNAVAILABLE: 545,
  },
  TAGS: {
    ANSWER: {
      INPUT_TYPE_NUMBER: 'INPUT_TYPE_NUMBER',
      INPUT_TYPE_EMAIL: 'INPUT_TYPE_EMAIL',
      INPUT_TYPE_PHONE: 'INPUT_TYPE_PHONE',
      SMOKER: 'SMOKER',
      GAMBLER: 'GAMBLER',
      SELECT_SECONDARY: 'SELECT_SECONDARY',
    },
    QUESTION: {
      BREAKPOINT: 'BREAKPOINT',
      BACK_NAV_OFF: 'BACK_NAV_OFF',
      LAST_PAGE_SUBMIT: 'LAST_PAGE_SUBMIT',
      STRUCTURED_ADDRESS: 'STRUCTURED_ADDRESS',
      STRUCTURED_CONTACT_DETAILS: 'STRUCTURED_CONTACT_DETAILS',
      STRUCTURED_PATIENT_DETAILS: 'STRUCTURED_PATIENT_DETAILS',
      LOGIN_PROVIDED_DATA: 'LOGIN_PROVIDED_DATA',
      PAIN_SCALE: 'PAIN_SCALE',
      SELECT_FLEXIBLE: 'SELECT_FLEXIBLE',
      S3_IMAGE_SOLUTION: 'S3_IMAGE_SOLUTION',
      DEMOGRAPHICS: {
        FIRSTNAME: 'FIRSTNAME',
        SURNAME: 'SURNAME',
        PARENT_FIRSTNAME: 'PARENT_FIRSTNAME',
        PARENT_SURNAME: 'PARENT_SURNAME',
        TELEPHONE: 'TELEPHONE',
        EMAIL: 'EMAIL',
        DATE_OF_BIRTH_ADULT: 'DATE_OF_BIRTH_ADULT',
        DATE_OF_BIRTH_PAED: 'DATE_OF_BIRTH_PAED',
        STRUCTURED_ADDRESS: 'STRUCTURED_ADDRESS',
        ADDRESS: 'ADDRESS',
        CITY: 'CITY',
        POSTCODE: 'POSTCODE',
        NHS_NUMBER: 'NHS_NUMBER',
        SEX: 'SEX',
        GENDER: 'GENDER',
        TITLE: 'TITLE',
        CHILD_TITLE: 'CHILD_TITLE',
        MARITAL_STATUS: 'MARITAL_STATUS',
        CHILD_MARITAL_STATUS: 'CHILD_MARITAL_STATUS',
      },
      SHOW_PATIENT_SEARCH: 'SHOW_PATIENT_SEARCH',
    },
  },
  INPUT_TYPES: {
    TEXT: 'text',
    NUMBER: 'number',
    EMAIL: 'email',
    PHONE: 'tel',
  },
  BIOMETRICS: {
    SYSTOLIC: {
      LOW: 80,
      HIGH: 180,
    },
    DIASTOLIC: {
      LOW: 50,
      HIGH: 120,
    },
    MAX_READINGS: 24,
  },
  NO_CHARACTER_COUNTER_BY_TAG: ['FIRSTNAME', 'SURNAME', 'PARENT_FIRSTNAME', 'PARENT_SURNAME', 'EMAIL'],
  DEMOGRAPHIC_QUESTION_IDS_TO_TAGS: {
    PRE_STD_ALL_DOB_CHILD: 'DATE_OF_BIRTH_PAED',
    PRE_STD_ALL_DOB_SELF_PAEDS_ONLY: 'DATE_OF_BIRTH_PAED',
    PRE_STD_ALL_DOB_SELF_WEB: 'DATE_OF_BIRTH_ADULT',
    PRE_STD_AD_DOB: 'DATE_OF_BIRTH_ADULT',
    PRE_STD_ALL_PARENT_DOB: 'DATE_OF_BIRTH_ADULT',
    POS_STD_AD_FIRSTNAME: 'FIRSTNAME',
    POS_STD_AD_SURNAME: 'SURNAME',
    POS_STD_AD_PARENT_FIRSTNAME: 'PARENT_FIRSTNAME',
    POS_STD_AD_PARENT_SURNAME: 'PARENT_SURNAME',
    POS_STD_AD_EMAIL: 'EMAIL',
    POS_STD_AD_PHONE: 'TELEPHONE',
    POS_STD_AD_ADDRESS_STRUCTURED: 'STRUCTURED_ADDRESS',
    POS_STD_AD_ADDRESS_ADDRESS: 'ADDRESS',
    POS_STD_AD_ADDRESS_CITY: 'CITY',
    POS_STD_AD_ADDRESS_POSTCODE: 'POSTCODE',
    POS_STD_AD_NHSNO: 'NHS_NUMBER',
    Q_GEC_SEL_ALL_STAFF_REPORTER_NAME: 'PREFERREDGP_NAME',
  },
  E_TRIAGE_QUESTION_GUIDANCE_IN_ANSWER: ['SINGLE', 'MULTIPLE', 'ALLMULTIPLE', 'FREETEXT', 'FREETEXTSHORT'],
  NHS_CONSENT_ERROR: 'access_denied',
  NHS_CONSENT_ERROR_DESCRIPTION: 'ConsentNotGiven',
  CUSTOMISATION_FLAG_NAMES: { FORCE_NHS_LOGIN: 'FORCE_NHS_LOGIN' },
  PREFILL_ENABLED: false,
  PREFILL_CLINICAL_REVIEW_ONLY: false,
  DEMOGRAPHICS_READONLY: false,
};
